import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EbasketApiMethodTypes, Providers, TMGiftCardGiveXSelectApi } from '@shared/interfaces';
import { SelectApiPopupComponent } from '@shared/select-api-popup/select-api-popup.component';
@Component({
  selector: 'givex-gift-card-configuration',
  templateUrl: './givex-gift-configuration.component.html',
  styleUrls: ['./givex-gift-configuration.component.scss']
})
export class TMGiveXGiftCardConfigurationComponent implements OnInit {
  @Input() action: string;
  @Input() parentForm: UntypedFormGroup;
  @Input() givexConfigurationDetails: any;
  @Input() authControlKey: string;
  isTMGiveXAddDisabled = false;
  tm_givex_select_api = [
    {
      id: 1,
      name: TMGiftCardGiveXSelectApi.CheckBalance,
      value: TMGiftCardGiveXSelectApi.CheckBalance,
      isDisabled: false
    },
    {
      id: 2,
      name: TMGiftCardGiveXSelectApi.ActivateNewCard,
      value: TMGiftCardGiveXSelectApi.ActivateNewCard,
      isDisabled: false
    },
    {
      id: 3,
      name: TMGiftCardGiveXSelectApi.TopUpCard,
      value: TMGiftCardGiveXSelectApi.TopUpCard,
      isDisabled: false
    },
    {
      id: 4,
      name: TMGiftCardGiveXSelectApi.Redemption,
      value: TMGiftCardGiveXSelectApi.Redemption,
      isDisabled: false
    },
    {
      id: 5,
      name: TMGiftCardGiveXSelectApi.MerchandiseCredit,
      value: TMGiftCardGiveXSelectApi.MerchandiseCredit,
      isDisabled: false
    },
    {
      id: 6,
      name: TMGiftCardGiveXSelectApi.CancelRedemption,
      value: TMGiftCardGiveXSelectApi.CancelRedemption,
      isDisabled: false
    }
  ];

  method_types = [
    { id: 1, name: EbasketApiMethodTypes.Get, value: EbasketApiMethodTypes.Get },
    { id: 2, name: EbasketApiMethodTypes.Post, value: EbasketApiMethodTypes.Post },
    { id: 3, name: EbasketApiMethodTypes.Put, value: EbasketApiMethodTypes.Put },
    { id: 4, name: EbasketApiMethodTypes.Patch, value: EbasketApiMethodTypes.Patch },
    { id: 5, name: EbasketApiMethodTypes.Delete, value: EbasketApiMethodTypes.Delete }
  ];

  constructor(private formBuilder: UntypedFormBuilder, private dialog: MatDialog) {}

  ngOnInit() {
    this.initForm();
    this.bindApiDetailsFormGroup();
  }
  initForm() {
    this.parentForm.addControl(
      this.authControlKey,
      this.formBuilder.group({
        username: [
          {
            value:
              this.givexConfigurationDetails &&
              this.givexConfigurationDetails.authenticationDetails &&
              this.givexConfigurationDetails.authenticationDetails.apiDetails
                ? Providers.SECRET
                : '',
            disabled: this.action === 'view' ? true : false
          },
          Validators.required
        ],
        password: [
          {
            value:
              this.givexConfigurationDetails &&
              this.givexConfigurationDetails.authenticationDetails &&
              this.givexConfigurationDetails.authenticationDetails.apiDetails
                ? Providers.SECRET
                : '',
            disabled: this.action === 'view' ? true : false
          },
          Validators.required
        ],
        authenticationKey: [
          {
            value:
              this.givexConfigurationDetails &&
              this.givexConfigurationDetails.authenticationDetailsKey
                ? this.givexConfigurationDetails.authenticationDetailsKey
                : '',
            disabled: this.action === 'view' ? true : false
          }
        ],
        tmGiftCardGivexApiDetails: this.formBuilder.array([])
      })
    );
  }

  isRequired(control: string) {
    let isRequired = false;
    const formControlObject = this.parentForm.get(this.authControlKey).get(control);
    if (formControlObject !== null) {
      if (formControlObject.validator !== null) {
        if (formControlObject.validator({} as AbstractControl) !== null) {
          isRequired = formControlObject.validator({} as AbstractControl).required ? true : false;
        }
      }
    }
    return isRequired ? true : false;
  }
  bindApiDetailsFormGroup() {
    const control = this.parentForm
      .get(this.authControlKey)
      .get('tmGiftCardGivexApiDetails') as UntypedFormArray;
    if (
      this.givexConfigurationDetails &&
      this.givexConfigurationDetails.authenticationDetails &&
      this.givexConfigurationDetails.authenticationDetails.apiDetails
    ) {
      this.givexConfigurationDetails.authenticationDetails.apiDetails.map((apis: any) => {
        let apiDetails = {};
        apiDetails = {
          url: [
            {
              value: apis.url,
              disabled: this.action === 'view' ? true : false
            },
            Validators.required
          ],
          method: [
            {
              value: apis.method,
              disabled: this.action === 'view' ? true : false
            },
            Validators.required
          ],
          selectedApi: [apis.selectedApi]
        };
        control.push(this.formBuilder.group(apiDetails));
        this.tm_givex_select_api.map((key) => {
          if (key.value === apis.selectedApi) {
            key.isDisabled = true;
          }
        });
      });
      if (this.tm_givex_select_api.length === control.length) {
        this.isTMGiveXAddDisabled = true;
      }
    }
  }
  openSelectApiPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = this.tm_givex_select_api.filter((api) => !api.isDisabled);
    const dialogRef = this.dialog.open(SelectApiPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result !== '') {
        this.tm_givex_select_api.map((element: any) => {
          if (element.value === result) {
            element.isDisabled = true;
            // this.tm_gift_card_api_details.push(element);
            const tmGiftCardGivexApiDetails = this.parentForm
              .get(this.authControlKey)
              .get('tmGiftCardGivexApiDetails') as UntypedFormArray;

            tmGiftCardGivexApiDetails.push(this.createApiDetailsFormGroup(result));
            if (this.tm_givex_select_api.length === tmGiftCardGivexApiDetails.length) {
              this.isTMGiveXAddDisabled = true;
            }
          }
        });
      }
    });
  }

  private createApiDetailsFormGroup(selectedApi: string): UntypedFormGroup {
    return new UntypedFormGroup({
      url: new UntypedFormControl('', Validators.required),
      method: new UntypedFormControl('', Validators.required),
      //deploy: new UntypedFormControl('', Validators.required),
      //script: new UntypedFormControl('', Validators.required),
      selectedApi: new UntypedFormControl(selectedApi)
    });
  }

  deleteApiDetailContainer(index: number) {
    const tmGiftCardGivexApiDetails = this.parentForm
      .get(this.authControlKey)
      .get('tmGiftCardGivexApiDetails') as UntypedFormArray;
    this.tm_givex_select_api.map((element: any) => {
      if (element.value === tmGiftCardGivexApiDetails.value[index].selectedApi) {
        element.isDisabled = false;
      }
    });
    if (tmGiftCardGivexApiDetails.length > 0) {
      tmGiftCardGivexApiDetails.removeAt(index);
    } else {
      tmGiftCardGivexApiDetails.reset();
    }
    if (this.tm_givex_select_api.length !== tmGiftCardGivexApiDetails.length) {
      this.isTMGiveXAddDisabled = false;
    }
  }
}
